import { createContext } from "react";

export type SocketStatus = 'connecting' | 'connected' | 'disconnected';

interface CableContextType {
  socket: WebSocket | null;
  socketStatus: SocketStatus;
  reconnect: () => void;
}

export const CableContext = createContext<CableContextType>({
  socket: null,
  socketStatus: 'disconnected',
  reconnect: () => {},
});

export const CableProvider = CableContext.Provider;
export const CableConsumer = CableContext.Consumer;
